import React, { PureComponent } from 'react';
import classNames from 'classnames';

import ConnectedRefundsForm from '../containers/ConnectedRefundsForm';

export default class AttendeeRefundRequestPage extends PureComponent {
    render() {
        return (
            <div>
                <ConnectedRefundsForm />
            </div>
        );
    }
}
